<div class="py-3 d-flex flex-column gap-3">
	<mat-card>
		<mat-card-title class="px-3 pt-3">Informacje podstawowe</mat-card-title>
		<mat-card-content class="p-3">
			<div class="row g-3">
				<div class="col-3">
					<div class="text-muted small mb-1">Navigator ID</div>
					<div class="fw-semibold">{{ contractor()?.navigatorId }}</div>
				</div>

				<div class="col-3">
					<div class="text-muted small mb-1">Prefiks</div>
					<div class="fw-semibold">{{ contractor()?.prefix }}</div>
				</div>

				<div class="col-6">
					<div class="text-muted small mb-1">Skrócona nazwa</div>
					<div class="fw-semibold">{{ contractor()?.shortName }}</div>
				</div>

				<div class="col-12">
					<div class="text-muted small mb-1">Pełna nazwa</div>
					<div class="fw-semibold">{{ contractor()?.fullName }}</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card>
		<mat-card-title class="px-3 pt-3">Adres</mat-card-title>
		<mat-card-content class="p-3">
			<div class="row g-3">
				<div class="col-6">
					<div class="text-muted small mb-1">Ulica</div>
					<div class="fw-semibold">{{ contractor()?.street }}</div>
				</div>

				<div class="col-3">
					<div class="text-muted small mb-1">Nr / lokal</div>
					<div class="fw-semibold">{{ contractor()?.address }}</div>
				</div>

				<div class="col-3">
					<div class="text-muted small mb-1">Kod pocztowy</div>
					<div class="fw-semibold">{{ contractor()?.zipCode }}</div>
				</div>

				<div class="col-6">
					<div class="text-muted small mb-1">Miasto</div>
					<div class="fw-semibold">{{ contractor()?.city }}</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card>
		<mat-card-title class="px-3 pt-3">Dane formalne i kontakt</mat-card-title>
		<mat-card-content class="p-3">
			<div class="row g-3">
				<div class="col-3">
					<div class="text-muted small mb-1">NIP</div>
					<div class="fw-semibold">{{ contractor()?.nip }}</div>
				</div>

				<div class="col-3">
					<div class="text-muted small mb-1">Telefon</div>
					<div class="fw-semibold">
						<app-inline-edit
							[value]="contractor()?.phone"
							[isLoading]="contractor()?.phoneLoader"
							inputType="tel"
							pattern="^(\+\d{1,3})?\s?\d{2,4}([\s\-]?\d{2,4}){1,3}$"
							(save)="savePhone($event)"
						/>
					</div>
				</div>

				<div class="col-6">
					<div class="text-muted small mb-1">Maile</div>
					<div class="fw-semibold">
						<app-inline-edit
							[value]="contractor()?.mails"
							[isLoading]="contractor()?.mailLoader"
							inputType="mail"
							tooltip="Możesz podać kilka adresów e-mail, oddzielając je przecinkiem (np. example@gmail.com, example2@gmail.com)"
							(save)="saveMails($event)"
						/>
					</div>
				</div>

				<div class="col-3">
					<div class="text-muted small mb-1">OSKAR</div>
					<div class="fw-semibold">{{ contractor()?.isOskar ? 'Tak' : 'Nie' }}</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>
